import React, { useState } from 'react';
import * as API from '../../lib/api';
import LoadingSpinner from '../atoms/loading-spinner';
import URLState from '../../data-containers/url-state';
import LocationDetails from '../../data-containers/location-details';

export default function(props){
  const { u, location, close } = props;
  const { fleetId } = URLState.useContainer();
  const { removeUser } = LocationDetails.useContainer();
  const [ busy, setBusy ] = useState(null);

  const onClickRemove = async (e) => {
    e.preventDefault();
    try {
      setBusy(true);
      await API.removeUserAccess(fleetId, u.id);
      removeUser(location.id, u.id);
      close();
    }
    catch(err) {
      console.error(err);
    }
    setBusy(false);  
  };

  return <React.Fragment>
    <h2>Are you sure you want to remove user {u.user.email_address} from the "{location.label}" location?</h2>
    <div className="button-list">
      <button onClick={close}>Cancel</button>
      <button 
        className="irreversible" 
        onClick={onClickRemove}
        disabled={busy}>Yes, remove user</button>
      {busy && <LoadingSpinner className="inline" />}
    </div>
  </React.Fragment>;
}